import { LabelGameStatusDefault } from '../../../components/labelGameStatus'

export class _LabelGameStatusCustom extends LabelGameStatusDefault {
  protected initPC(): this {
    super.initPC()
    this['--label-game-status-z-index'] = '1'
    return this
  }
  protected initH5(): this {
    super.initH5()
    this['--label-game-status-z-index'] = '1'
    return this
  }
}
